<template>
  <teleport to="body">
    <div @click="dialogVisible = false" class="dialog-box" v-if="dialogVisible">
      <div @click.stop="" class="dialog-contnet">
        <h2>{{ $t("dialog.text14") }}</h2>

        <p>{{ $t("dialog.text15") }}</p>

        <div class="button">
          <div @click.stop="dialogVisible = false" class="btn1 btn">
            {{ $t("dialog.text12") }}
          </div>
          <div @click.stop="handleOpen" class="btn2 btn">{{ $t("dialog.text16") }}</div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { CircleCheckFilled } from "@element-plus/icons-vue";
import { useGetLanguage } from "@/hooks/useGetLanguage";

const dialogVisible = defineModel();

const { contactUrl, contactAddress } = useGetLanguage();

function preventScroll(e: any) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

function handleOpen() {
  window.open(contactAddress.value);
  dialogVisible.value = false;
}
watch(
  dialogVisible,
  (val) => {
    if (val) {
      document.addEventListener("wheel", preventScroll, { passive: false });
    } else {
      document.removeEventListener("wheel", preventScroll);
    }
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
.dialog-box {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .dialog-contnet {
    width: 460px;
    background-color: #fff;
    border-radius: 16px 16px 16px 16px;
    padding: 36px;

    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #1d212d;
      text-align: left;
    }
    > p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #667085;
      text-align: left;
      margin-top: 12px;
    }

    ul {
      margin: auto;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #9038ff;
      margin-top: 40px;
      margin-bottom: 24px;
      span {
        margin-left: 6px;
      }
    }

    .info {
      margin: auto;
      text-align: center;
      img {
        width: 160px;
        height: 160px;
      }
    }

    .button {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-weight: 500;
      font-size: 24px;
      transition: all 0.3s;
      cursor: pointer;
      margin-top: 40px;

      .btn {
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #9038ff;
        padding: 6px 24px;
        margin-left: 20px;
      }

      .btn2 {
        background: #7815f5;
        color: #fff;
      }
    }
  }
}
</style>
